precision highp float;

#define M_PI 3.1415926535897932384626433832795

#pragma glslify: noise2d = require('glsl-noise/simplex/2d')
#pragma glslify: noise3d = require('glsl-noise/simplex/3d')
#pragma glslify: noise4d = require('glsl-noise/simplex/4d')
#pragma glslify: rotate2d = require('../lib.glsl')
#pragma glslify: ease = require(glsl-easings/quartic-in)
#pragma glslify: random = require(glsl-random) 

varying vec2 vUv;
varying vec3 vPosition;

uniform float uSmoothstepControl;
uniform vec3 uColourSky;
uniform vec3 uColourHorizon;
uniform vec3 uColourHighlight;
uniform vec3 uSunPosition;
uniform float uFractalNoiseCount;
uniform float uTime;

float scaleMulti = 0.5;
float scaleU = 0.002;
float scaleV = 0.005;
float timeScale = 0.4;

float oscilateTriangular(float x) {
  return abs(2. * fract(x) - 1.);;
}

void fractalNoise4d(inout float value, in vec3 lookup, in float levelIndex, in float levelCount) {
  float strength = 1.0 / levelIndex;

  vec4 lookupWithTime = vec4(lookup / strength, uTime * timeScale);
  float noiseValue = (noise4d(lookupWithTime) * 0.5) + 0.5;

  value = value + (noiseValue / levelCount);
}

vec3 carthesianToSphericalPolar(vec3 position) {
  float r = sqrt(position.x * position.x + position.y * position.y + position.z * position.z);
  float theta = atan(position.y, position.x);
  float phi = atan(sqrt(position.x * position.x + position.y * position.y), position.z);
  return vec3(r, theta, phi);
}

vec3 sphericalPolarToCarthesian(vec3 position) {
  float r = position.x;
  float theta = position.y;
  float phi = position.z;
  float x = r * cos(theta) * sin(phi);
  float y = r * sin(theta) * sin(phi);
  float z = r * cos(phi);
  return vec3(x, y, z);
}

void main() {
  float u = oscilateTriangular(vUv.x);
  float v = vUv.y;

  vec3 stretch = vec3(1.0, 1.0, 1.0);

  vec3 spericalPolarPosition = carthesianToSphericalPolar(vPosition);
  spericalPolarPosition.x = 1.0;
  vec3 positionCarthesianNormalised = sphericalPolarToCarthesian(spericalPolarPosition) * stretch;

  vec3 sunPosition = uSunPosition;
  // sunPosition.y = cos(uTime) * M_PI;

  sunPosition.y = uTime * 0.0066;
  sunPosition.z = uTime * 0.0066;
  vec3 sunPositionNormalised = vec3(1.0, sunPosition.y, sunPosition.z);
  vec3 sunPositionCarthesianNormalised = sphericalPolarToCarthesian(sunPositionNormalised) * stretch;

  float distanceToSun = distance(sunPositionCarthesianNormalised, positionCarthesianNormalised);
  float sunStrength = 1.0 - smoothstep(distanceToSun * 15.0, 0.0, 0.5);

  float gradientProgress = smoothstep(uSmoothstepControl, 0.7, vUv.y);

  // vec2 rotatedPosition = vec2(vPosition.x, vPosition.z);
  // float rotateAmount = noise2d(vec2(u, v) * 1.0);
  // float rotateAmount = 0.0;

  // vec2 rotatedPosition = rotate2d(vec2(vPosition.x, vPosition.z), rotateAmount);
  vec3 noiseLookup = vec3(vPosition.x * scaleU * scaleMulti, vPosition.y * scaleV * scaleMulti, vPosition.y * scaleU * scaleMulti);

  float noiseValue = 0.0;
  int count = int(uFractalNoiseCount);
  for(int i = 0; i < count; i++) {
    fractalNoise4d(noiseValue, noiseLookup, float(i + 1), float(count));
  }

  vec3 skyWithEffectColour = uColourSky + (uColourHighlight * noiseValue * 0.5);
  vec3 baseColour = mix(uColourHorizon, skyWithEffectColour, gradientProgress);
  // vec3 baseColour = skyColour + (uColourHighlight * noiseValue * 0.5);
  vec3 sunColour = vec3(1.0, 1.0, 1.0);

  gl_FragColor = vec4(baseColour + (sunColour * sunStrength * 0.75), 1.0);
}